import { QueryClient, useMutation, useQuery, useQueryClient, UseQueryOptions } from "@tanstack/react-query";
import Api from "../../features/one-query/services/ApiServices";
import { useAppDispatch } from "../hooks";
import { removeWorkflowById, removeWorkflowRunById, setAllWorkflowRuns, setAllWorkflows, setCurrentWorkflowRunData, setCurrentWorkflowSelected, setSelectedWorkflowRun, UpadteWorkflowById } from "../one-query/workflowsSlice";
import { useNavigate, useParams } from "react-router-dom";
import { setFileError, setSnackBarAlert } from "../one-query/chatsSlice";
import { Dayjs } from "dayjs";
import { useDispatch } from "react-redux";

interface GenerateWorkflowResponseTextSuitesTypes{
 workflowId:string;
 connectionId:string;
 prompt:string
}
export interface getAllWorkflowRunParams{
  FromDate?: Dayjs | null,
  ToDate?: Dayjs  | null,
  Page?: number | null,
  ItemsPerPage?: number | null,
  SortBy?: string | null,
  SortDesc?: boolean | null,
  Search?: string | null,
}

// Get All Workflows
const getAllWorkflows = async () => {
    const response = await Api.get("Workflow/GetAllWorkflows?ItemsPerPage=-1");
    return response.data;
};


export const useGetAllWorkFlows = () => {
  return useQuery({
    queryKey: ["GetAllWorkflows"],
    queryFn: getAllWorkflows,
  });
};
const getWorkflowTemplates = async () => {
    const response = await Api.get("Workflow/Templates");
    return response.data;
};

export const useGetWorkFlowTemplates = () => {
  return useQuery({
    queryKey: ["GetWorkflowTemplates"],
    queryFn: getWorkflowTemplates,
  });
};


  // Get workflow by id
const getWorkflowById = async (workflowId:string) => {
  try {
    const response = await Api.get(`Workflow/GetWorkflowById?id=${workflowId}`);
    return response.data;
  } catch (e) {}
};

export const useGetWorkFlow = (workflowId: string) => {
  return useQuery({
    queryKey: ["GetWorkflowById", workflowId],
    queryFn: ({ queryKey }) => {
      const [, id] = queryKey;
      return getWorkflowById(id as string);
    },
  });
};

////////create new workflow
  const CreateNewWoekflow = async (data:FormData) => {
  try {
      const response = await Api.post("Workflow/CreateWorkflow", data,{
      headers: {
        "Content-Type": "multipart/form-data",
      },
  });
    return response.data;
  } catch (e) {
      throw e
  }
};

const useCreateworkflow = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["CreateNewWorkflow"],
    mutationFn: CreateNewWoekflow,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey:["GetAllWorkflows"]})
    }
  });
};

export const useCreateWorkflow = () => {
  const createNewWorkflowMutation = useCreateworkflow();
  const dispatch = useAppDispatch();
    const navigate=useNavigate();
    const queryClient = useQueryClient();
    const CreateWorkflow = (data:FormData) => {
    createNewWorkflowMutation.mutate(data, {
      onSuccess: (response: any) => {
        if(window.location.pathname==="/workflows"){
           queryClient.invalidateQueries({
          queryKey:["GetAllWorkflows"]
      })}
      else
        navigate("/workflows")
      },
      onError: (error) => {
        dispatch(
          setFileError({
            isError: true,
              errorMsg:
                "Workflow already exists. Please enter a new name.",
            reason: "user upload file type not support",
          })
        );
      },
    });
  };

    return {
      CreateWorkflow,
      status: createNewWorkflowMutation.status,
    };
};


/////Generate workflow response
const generateWorkflowResponse = async (data:FormData) => {
  try {
    const response = await Api.post(`Workflow/RunWorkflow`,data,{
      headers: {
        "Content-Type": "multipart/form-data", // Ensure correct format
      },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

const useGenerateResponseTextSuites = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationKey: ["GenerateWorkflowTextSuitesResponse"],
    mutationFn: generateWorkflowResponse,
    onError: (error: any) => {
      const errorMsg = error?.response.data;
      if (errorMsg) {
          dispatch(setSnackBarAlert({
          show: true,
          message: errorMsg,
          alertType: "error",
        }));
      }
       }
   
  });
};

export const useGenerateWorkflowTextSuitesResponse = () => {
  const generateResponseMutation = useGenerateResponseTextSuites();
  const dispatch = useAppDispatch();
  const GenerateResponse = (data:FormData) => {
    generateResponseMutation.mutate(data, {
      onSuccess: (data) => {
        dispatch(setCurrentWorkflowRunData(data))
      },
      onError: (error) => {},
    });
  };

  return GenerateResponse;
};

///Delete workflow
const deleteWorkflow = async (workflowId:string) => {
  try {
    const response = await Api.delete(`Workflow/DeleteWorkflow?id=${workflowId}`);
    return response.data;
  } catch (e) {
    throw e
  }
};

const useDeleteWorkflow = () => {
  return useMutation({
    mutationKey: ["DeleteWorkflow"],
    mutationFn: deleteWorkflow,
  });
};

export const useDeleteworkflow = () => {
  const deleteWorkflowMutation = useDeleteWorkflow();
  const dispatch = useAppDispatch();
  const navigate=useNavigate()
  const { workflowId } = useParams<{ workflowId: string }>();
  const queryClient = useQueryClient();
  const DeleteWorkflow = (Id:string) => {
    deleteWorkflowMutation.mutate(Id, {
      onSuccess: (data: any) => {
        if(workflowId===Id)
        navigate("/workflows")
      else
      queryClient.invalidateQueries({
          queryKey:["GetAllWorkflows"]
      })
      },
      onError: (e:any) => {
        const errorMsg = e?.response?.data;
        dispatch(
        setSnackBarAlert({
          show: true,
          message: errorMsg,
          alertType: "error",
        })
      );
      },
    });
  };

  return DeleteWorkflow;
};

//////update workflow
const Updateworkflow = async (data:FormData) => {
  try {
    const response = await Api.patch("Workflow/UpdateWorkflow", data,{
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (e) {
    throw e
  }
};

const useUpadteworkflow = () => {
  return useMutation({
    mutationKey: ["UpadteWorkflow"],
    mutationFn: Updateworkflow,
  });
};

export const useupadteWorkflow = () => {
  const updateWorkflowMutation = useUpadteworkflow();
  const dispatch = useAppDispatch();
  const navigate=useNavigate()
  const upadteWorkflow = (data:FormData) => {
    updateWorkflowMutation.mutate(data, {
      onSuccess: (response: FormData) => {
        dispatch(UpadteWorkflowById(response))
        navigate("/workflows")
      },
      onError: (e: any) => {
        const errorMsg = e?.response?.data;
        dispatch(
        setSnackBarAlert({
          show: true,
          message: errorMsg,
          alertType: "error",
        })
      );
      }
    });
  };

  return upadteWorkflow;
};

//get All workflows run 
const getAllWorkflowRuns = async (params: getAllWorkflowRunParams) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.FromDate)
      queryParams.append("FromDate", params.FromDate.format('YYYY-MM-DD'));
    if (params.ToDate) queryParams.append("ToDate", params.ToDate.format('YYYY-MM-DD'));
    if (params.Page) queryParams.append("Page", String(params.Page)); // Convert to string
    if (params.ItemsPerPage)
      queryParams.append("ItemsPerPage", String(params.ItemsPerPage)); // Convert to string
    if (params.SortBy) queryParams.append("SortBy", String(params.SortBy));
    if (params.SortDesc)
      queryParams.append("SortDesc", String(params.SortDesc)); // Convert to string
    if (params.Search) queryParams.append("Search", String(params.Search));
    const response = await Api.get(
      `Workflow/GetAllWorkflowRuns?${queryParams.toString()}&ItemsPerPage=-1`
    );
    return response.data;
  } catch (e) {}
};
export const useGetAllWorkflowRuns = (params: getAllWorkflowRunParams) => {
  return useQuery({
    queryKey: ["GetAllWorkflowRuns", params],
    queryFn: () => getAllWorkflowRuns(params),
    enabled:!!params
  });
};

//get All workflow runs By Id
const getWorkflowRunById = async (workflowRunId:string) => {
  try {
    const response = await Api.get(`Workflow/GetWorkflowRunById?id=${workflowRunId}`);
    return response.data;
  }catch (e) {
    throw e; 
  }
};

export const useGetWorkFlowRunId = (workflowRunId: string) => {
  return useQuery({
    queryKey: ["GetWorkflowRunById",workflowRunId],
    queryFn: () => getWorkflowRunById(workflowRunId),
    enabled:!!workflowRunId
  });
};

///Delete workflow run by Id
const deleteWorkflowRun = async (workflowRunId:string) => {
  try {
    const response = await Api.delete(`Workflow/DeleteWorkflowRun?id=${workflowRunId}`);
    return response.data;
  } catch (e) {}
};

const useDeleteWorkflowRun = () => {
  return useMutation({
    mutationKey: ["DeleteWorkflowRun"],
    mutationFn: deleteWorkflowRun,
  });
};

export const useDeleteworkflowRunById = () => {
  const deleteWorkflowRunMutation = useDeleteWorkflowRun();
  const dispatch = useAppDispatch();
  const DeleteWorkflow = (workflowId:string) => {
    deleteWorkflowRunMutation.mutate(workflowId, {
      onSuccess: (data) => {
        dispatch(removeWorkflowRunById(workflowId))
      },
      onError: (error:any) => {
        const errorMsg = error?.response?.data;
        dispatch(
          setSnackBarAlert({
            show: true,
            message: errorMsg,
            alertType: "error",
          })
        );
      },
    });
  };

  return DeleteWorkflow;
};

///Delete all workflow run
const deleteAllWorkflowRun = async () => {
  try {
    const response = await Api.delete(`Workflow/ClearAllWorkflowRuns`);
    return response.data;
  } catch (e) {}
};

const useDeleteAllWorkflowRun = () => {
  return useMutation({
    mutationKey: ["DeleteAllWorkflowRun"],
    mutationFn: deleteAllWorkflowRun,
  });
};

export const useDeleteAllWorkflowRuns = () => {
  const deleteAllWorkflowRunsMutation = useDeleteAllWorkflowRun();
  const dispatch = useAppDispatch();
  const DeleteWorkflow = () => {
    deleteAllWorkflowRunsMutation.mutate(undefined, {
      onSuccess: () => {
        dispatch(setAllWorkflowRuns([]))
      },
      onError: (error) => {},
    });
  };

  return DeleteWorkflow;
};

//////////////clone workflow
  const cloneWoekflow = async (data: {
    workflowId: string;
    workflowName: string;
  }) => {
    try {
      const response = await Api.post("Workflow/Clone",data);
      return response.data;
    } catch (e) {
      throw e;
    }
  };

 const useCloneworkflow = () => {
    return useMutation({
      mutationKey: ["Clone Workflow"],
      mutationFn: (data: { workflowId: string; workflowName: string }) =>
        cloneWoekflow(data),
    });
  };

  export const useCloneWorkflow = () => {
  const cloneWorkflowMutation = useCloneworkflow();
  const queryClient = useQueryClient();
  const dispatch=useAppDispatch()
  const CloneWorkflow = (data: { workflowId: string; workflowName: string }) => {
    cloneWorkflowMutation.mutate(data, {
      onSuccess: (data: any) => {
      queryClient.invalidateQueries({
          queryKey:["GetAllWorkflows"]
      })
      },
      onError: (e:any) => {
         dispatch(
          setFileError({
            isError: true,
              errorMsg:
                "Workflow already exists. Please enter a new name.",
            reason: "user upload file type not support",
          })
        );
      },
    });
  };

  return {
    CloneWorkflow,
    isSuccess: cloneWorkflowMutation.isSuccess,
  };;
};